// extracted by mini-css-extract-plugin
export default {"imageWrapper":"P2PPage_imageWrapper__zSJKH","fieldGroup":"P2PPage_fieldGroup__xBVSF"};